module.exports = __webpack_public_path__ + "media/images/okra-offers/Rewards-Earn-03-a83112495bcae3282746d719fdfd3ec8.jpg";